import { render, staticRenderFns } from "./profile-item.vue?vue&type=template&id=f3a688d0&"
import script from "./profile-item.vue?vue&type=script&lang=ts&"
export * from "./profile-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports